import {
  BATCH_PREFERENCE_ACCESS_PREFIX,
  BATCH_PREFERENCE_STORAGE_PREFIX,
  BATCH_PREFERENCE_STORAGE_STATUS,
} from "constants/batchPreference";

const storageKey = (orderId) =>
  `${BATCH_PREFERENCE_STORAGE_PREFIX}.${orderId}`;

const accessKey = (orderId) =>
  `${BATCH_PREFERENCE_ACCESS_PREFIX}.${orderId}`;

const readRecord = (orderId) => {
  if (!orderId) return null;
  try {
    const raw = localStorage.getItem(storageKey(orderId));
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

const writeRecord = (orderId, record) => {
  if (!orderId) return false;
  try {
    localStorage.setItem(storageKey(orderId), JSON.stringify(record));
    return true;
  } catch (error) {
    return false;
  }
};

const isValidStoredProgram = (program) =>
  Boolean(program && typeof program === "object" && program.id != null && program.id !== "");

export const grantBatchPreferenceAccess = (orderId) => {
  if (!orderId) return false;
  try {
    sessionStorage.setItem(accessKey(orderId), "1");
    return true;
  } catch (error) {
    return false;
  }
};

export const hasBatchPreferenceAccess = (orderId) => {
  if (!orderId) return false;
  try {
    return sessionStorage.getItem(accessKey(orderId)) === "1";
  } catch (error) {
    return false;
  }
};

export const clearBatchPreferenceAccess = (orderId) => {
  if (!orderId) return;
  try {
    sessionStorage.removeItem(accessKey(orderId));
  } catch (error) {
    return;
  }
};

export const getCompletedBatchDecisions = (orderId) => {
  const record = readRecord(orderId);
  if (
    record?.status !== BATCH_PREFERENCE_STORAGE_STATUS.COMPLETED &&
    record?.status !== BATCH_PREFERENCE_STORAGE_STATUS.PAYMENT_ENTERED
  ) {
    return null;
  }
  if (!Array.isArray(record.programs)) return null;
  const programs = record.programs.filter(isValidStoredProgram);
  return programs.length ? programs : null;
};

export const hasEnteredPaymentDetails = (orderId) => {
  const record = readRecord(orderId);
  return record?.status === BATCH_PREFERENCE_STORAGE_STATUS.PAYMENT_ENTERED;
};

export const saveCompletedBatchDecisions = (orderId, programs) => {
  writeRecord(orderId, {
    status: BATCH_PREFERENCE_STORAGE_STATUS.COMPLETED,
    programs,
    updatedAt: new Date().toISOString(),
  });
};

export const markPaymentDetailsEntered = (orderId) => {
  const existing = readRecord(orderId) || {};
  writeRecord(orderId, {
    ...existing,
    status: BATCH_PREFERENCE_STORAGE_STATUS.PAYMENT_ENTERED,
    updatedAt: new Date().toISOString(),
  });
  clearBatchPreferenceAccess(orderId);
};

export const clearIncompleteBatchDecisions = (orderId) => {
  const record = readRecord(orderId);
  if (!record) return;
  if (record.status === BATCH_PREFERENCE_STORAGE_STATUS.COMPLETED) return;
  if (record.status === BATCH_PREFERENCE_STORAGE_STATUS.PAYMENT_ENTERED) return;
  localStorage.removeItem(storageKey(orderId));
};

export const clearCompletedBatchDecisions = (orderId) => {
  if (!orderId) return;
  localStorage.removeItem(storageKey(orderId));
};
